import http from '../../utils/services/http';
import { GetTagsRequestParams } from '../../../common/api/tags/tagRouteTypes';
import { BoardVirtualPathMap, TaggedElementsData } from '../../../common/api/tags/tagElementsRetrievalRouteTypes';

export const fetchTagsFromDb = async (params: GetTagsRequestParams = {}) => {
    const response = await http({
        method: 'get',
        url: `tags`,
        params,
    });

    return response.data.tags;
};

export const getTagUsageData = async (
    tagId: string,
    userRootBoard: string,
): Promise<{
    taggedElements: TaggedElementsData[];
    boardVirtualPathToRootMap: BoardVirtualPathMap;
}> => {
    const response = await http({
        method: 'get',
        url: `tags/${tagId}/usage`,
        params: { userRootBoard },
    });

    return response.data;
};
